import React, { forwardRef } from 'react';
import SelectionList from './SelectionList';

/**
 * @typedef {object} SelectionListMultiSelectOptions
 * @property {string} label
 * @property {number} value
 * @property {*} [labelRendered]
 */

/**
 * @typedef {object} SelectionListMultiSelectOwnProps
 * @property {SelectionListMultiSelectOptions[]} options
 * @property {number|Array<number>} [value]
 * @property {(selectedValues: Array<number>) => void} [onChange]
 */

/**
 * @typedef {SelectionListMultiSelectOwnProps &
 *   React.ComponentPropsWithoutRef<typeof SelectionList>} SelectionListMultiSelectProps
 */

/**
 * @type {React.ForwardRefExoticComponent<SelectionListMultiSelectProps & React.RefAttributes<*>>}
 * @param {SelectionListMultiSelectProps} props
 */
export const SelectionListMultiSelect = forwardRef((props, ref) => {
  const { options, value, onChange, ...selectionListProps } = props;

  const onSelectHandlerInner = selections => {
    const selectedValues = selections.map(s => s.value);
    onChange(selectedValues);
  };

  return (
    <SelectionList
      ref={ref}
      {...selectionListProps}
      onSelectHandler={onSelectHandlerInner}
      selectedValue={getSelectedOptions(options, value)}
      list={options}
      multiSelect
      allowAutocomplete={false}
      showInputEndAdornment={false}
    />
  );
});

SelectionListMultiSelect.displayName = 'SelectionListMultiSelect';

const getSelectedOptions = (allOptions, selectedOptions) =>
  !selectedOptions?.length ? [] : allOptions.filter(item => selectedOptions.includes(item.value));
